<template>
  <section class="module-weekly">
    <div class="container">
      <div class="columns">
        <div class="column">
          <Skeletor class="wbb-box" width="100%" height="510" />
        </div>
      </div>
    </div>
    <div class="module-boxes">
      <div class="container">
        <div class="columns block-box">
          <div class="column is-3-desktop is-6-tablet is-6-mobile">
            <Skeletor class="mb-box" width="100%" height="445" />
          </div>
          <div class="column is-3-desktop is-6-tablet is-6-mobile">
            <Skeletor class="mb-box" width="100%" height="445" />
          </div>
          <div class="column is-3-desktop is-6-tablet is-6-mobile">
            <Skeletor class="mb-box" width="100%" height="445" />
          </div>
          <div class="column is-3-desktop is-6-tablet is-6-mobile">
            <Skeletor class="mb-box" width="100%" height="445" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup></script>
